// extracted by mini-css-extract-plugin
export default {"video":"EG7Tj9"};